import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedicalCross = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ _jsx("path", { d: "M15,9h6v6h-6v6h-6" }), /* @__PURE__ */ _jsx("path", { d: "M9,15h-6v-6h6v-6h6" })]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgMedicalCross;
